import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import { Button, Input } from '@ipc/ipc-components';
import DateFnsUtils from '@date-io/date-fns';
import Grid from '@material-ui/core/Grid';
import { KeyboardDateTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import moment from 'moment';
import locale from 'date-fns/locale/en-US';
import { postPredesTransactionsReleaseRequestActionCreator } from '../redux/actions/PredesTransactionsReleaseActions';
import { getAssetType } from '../../../../../../common/asset-types/redux/selectors/AssetTypesSelectors';
import DATE_FORMATS from '../../../../../../common/models/constants/dateFormats';

if (locale && locale.options) {
  locale.options.weekStartsOn = 1;
}

class PredesTransactionsReleaseDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      despatchId: props.row.row.despatchId,
      departureDateTime: props.row.row.departureDateTime !== undefined ? props.row.row.departureDateTime : props.row.row.departureDate,
      plannedArrivalDateTime: props.row.row.arrivalDateTime !== undefined ? props.row.row.arrivalDateTime : props.row.row.arrivalDate,
      transactionId: props.row.row.id,
    };
    this.handleComments = this.handleComments.bind(this);
    this.handleDepartureDate = this.handleDepartureDate.bind(this);
    this.handleArrivalDate = this.handleArrivalDate.bind(this);
    this.confirmRelease = this.confirmRelease.bind(this);
  }

  isFormValid = () => !(this.state.departureDateTime === 'Invalid date'
    || this.state.plannedArrivalDateTime === 'Invalid date'
    || this.state.plannedArrivalDateTime === null
    || moment(this.state.departureDateTime).isAfter(moment(this.state.plannedArrivalDateTime)))

  handleComments(e) {
    this.setState({
      comment: e.target.value,
    });
  }

  handleDepartureDate(date) {
    this.setState({
      departureDateTime: moment(date).set({ second: 0 }).format(DATE_FORMATS.inputDateTime),
    });
  }

  handleArrivalDate(date) {
    this.setState({
      plannedArrivalDateTime: moment(date).set({ second: 0 }).format(DATE_FORMATS.inputDateTime),
    });
  }

  async confirmRelease() {
    await this.props.postPredesTransactionsReleaseRequestActionCreator(
      this.props.appContext,
      this.state.plannedArrivalDateTime,
      this.state.comment,
      this.state.departureDateTime,
      [this.state.transactionId],
    );
    this.props.closeDialog();
    this.props.refreshTransactions();
    this.props.refreshHistories();
  }

  render() {
    return (
      <Dialog onClose={this.props.closeDialog} aria-labelledby="simple-dialog-title" open={this.props.openDialog}>
        <DialogTitle id="simple-dialog-title">Release Transaction</DialogTitle>
        <div style={{ float: 'left' }}>
          <table className="form-table">
            <tbody>
              <tr>
                <td>Despatch ID</td>
                <td>
                  <Input value={this.state.despatchId} huge disabled />
                </td>
              </tr>
              <tr>
                <td>
                  Departure date & time
                </td>
                <td>
                  <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
                    <Grid container justify="space-around">
                      <KeyboardDateTimePicker
                        autoOk
                        disableToolbar
                        variant="inline"
                        format="dd-MM-yyyy HH:mm"
                        ampm={false}
                        margin="normal"
                        id="date-picker-inline"
                        value={this.state.departureDateTime}
                        onChange={this.handleDepartureDate}
                        maxDate={this.state.plannedArrivalDateTime}
                        maxDateMessage="Departure date & time can not be after arrival date & time"
                        strictCompareDates
                        KeyboardButtonProps={{
                          'aria-label': 'change date',
                        }}
                      />
                    </Grid>
                  </MuiPickersUtilsProvider>
                </td>
              </tr>
              <tr>
                <td>
                  Arrival date & time
                </td>
                <td>
                  <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
                    <Grid container justify="space-around">
                      <KeyboardDateTimePicker
                        autoOk
                        disableToolbar
                        variant="inline"
                        format="dd-MM-yyyy HH:mm"
                        ampm={false}
                        margin="normal"
                        id="date-picker-inline"
                        value={this.state.plannedArrivalDateTime}
                        onChange={this.handleArrivalDate}
                        minDate={this.state.departureDateTime}
                        minDateMessage="Departure date & time can not be after arrival date & time"
                        strictCompareDates
                        KeyboardButtonProps={{
                          'aria-label': 'change date',
                        }}
                      />
                    </Grid>
                  </MuiPickersUtilsProvider>
                </td>
              </tr>
              <tr>
                <td>
                  Comment
                </td>
                <td>
                  <Input
                    value={this.state.comment}
                    onChange={this.handleComments}
                    maxLength="40"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="after-box">
          <Button style={{ marginLeft: '25px', marginBottom: '10px' }} onClick={this.props.closeDialog}>Cancel</Button>
          <Button
            style={{ float: 'right', marginRight: '50px', marginBottom: '10px' }}
            onClick={this.confirmRelease}
            className={`primary-button-${!this.isFormValid()}`}
            disabled={!this.isFormValid()}
          >
            Confirm Release
          </Button>
        </div>
      </Dialog>
    );
  }
}

PredesTransactionsReleaseDialog.propTypes = {
  row: PropTypes.objectOf(PropTypes.shape),
  appContext: PropTypes.objectOf(PropTypes.shape),
  postPredesTransactionsReleaseRequestActionCreator: PropTypes.func,
  openDialog: PropTypes.func.isRequired,
  closeDialog: PropTypes.func.isRequired,
  refreshTransactions: PropTypes.func,
  refreshHistories: PropTypes.func,
};

function mapStateToProps(state) {
  return {
    appContext: getAssetType(state),
  };
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  postPredesTransactionsReleaseRequestActionCreator,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(PredesTransactionsReleaseDialog);
